import { Participant, Room } from 'livekit-client';
import { MobileViewer } from 'features/ParticipantItem/presenters/Mobile';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useParticipantSubscriptions } from 'hooks/useParticipantSubscriptions';
import { useParticipantElementRefs } from 'hooks/useParticipantElementRefs';
import { participantListOrderSort } from 'useCase';
import { MobileParticipant, ParticipantsArea, ParticipantWrapper } from './view';

interface Props {
    participants: Participant[];
    room?: Room;
    speakerParticipantId?: string;
    isHideSpeakingBorder?: boolean;
}

export const MobileParticipantsList = ({ participants, room, speakerParticipantId, isHideSpeakingBorder }: Props) => {
    const { checkIsHandRaised } = useRaiseHand();
    const sortedParticipants = participantListOrderSort(participants, checkIsHandRaised);

    const { setElementRef } = useParticipantSubscriptions({
        room,
        participants: sortedParticipants,
        maxVisible: 8,
        isSidebarMode: true,
        speakerParticipantId,
        threshold: 0.6,
    });

    const elementRefs = useParticipantElementRefs(setElementRef, sortedParticipants);

    return (
        <ParticipantsArea>
            {sortedParticipants.map((participant) => {
                return (
                    <ParticipantWrapper
                        key={participant.identity}
                        ref={elementRefs.get(participant.identity)}
                        data-participant-id={participant.identity}
                    >
                        <MobileParticipant
                            participant={participant}
                            PresenterComponent={MobileViewer}
                            isHideSpeakingBorder={isHideSpeakingBorder}
                        />
                    </ParticipantWrapper>
                );
            })}
        </ParticipantsArea>
    );
};
